import { OwcButton } from "@one/react";
// @ts-ignore
import { Variant } from "@one/web-components/dist/index.cjs.js";
import { useFormikContext } from "formik";
import React from "react";
import { react18WorkaroundProps } from "../../../../utils/constants/react18WorkaroundProps";

type Props = {
  confirmText?: string;
  confirmButtonVariant: Variant;
};

export const FormSubmitButton = ({ confirmButtonVariant, confirmText = "OK" }: Props) => {
  const {
    isValid,
    validateForm,
    setTouched,
    submitForm
  } = useFormikContext();

  const markAllTouched = (errObj: any): any => {
    if (typeof errObj !== "object" || errObj === null) return true;
    return Object.keys(errObj).reduce((acc, key) => {
      acc[key] = markAllTouched(errObj[key]);
      return acc;
    }, {} as Record<string, any>);
  };

  return (
    <OwcButton
      {...react18WorkaroundProps}
      style={{ margin: 2 }}
      variant={confirmButtonVariant}
      onClick={async (e: React.MouseEvent<HTMLOwcButtonElement>) => {
        const errors = await validateForm();
        if (Object.keys(errors).length > 0) {
          setTouched(markAllTouched(errors));
        } else {
          submitForm();
        }
      }}
      disabled={!isValid}
    >
      {confirmText}
    </OwcButton>
  );
};
